import { useAuthSelector } from 'app/data/auth';
import { sdk } from 'app/sdk';
import { QueryKey, useQuery, UseQueryOptions } from 'react-query';
import { GroupsPageResponse } from 'types/group';
import { MediasPageResponse } from 'types/media';
import mediaQueryKeys from './mediaQueryKeys';

interface QueryParams {
  skip?: number;
  take?: number;
  orderBy?: any;
  filters?: any;
  options?: Omit<
    UseQueryOptions<MediasPageResponse, Error, MediasPageResponse, QueryKey>,
    'queryKey' | 'queryFn'
  >;
}

export const useListMediasQuery = ({
  skip = 0,
  take = 10000,
  orderBy = [['name', 'asc']],
  filters = {},
  options,
}: QueryParams) => {
  // returns list of medias
  // - just get ALL medias+relations
  // - TODO v2: can be filtered/etc
  const authState = useAuthSelector();
  const queryKey = mediaQueryKeys.list(skip, take, orderBy, filters);

  const query = useQuery<MediasPageResponse, Error>(
    queryKey,
    () =>
      sdk.media.query.medias(
        {
          skip,
          take,
          orderBy,
          filters,
        },
        { authToken: authState.auth_token },
      ),
    {
      // enabled: authState?.auth_token_decoded?.owner_id ? true : false,

      // prevents pagination from looking like a hard load;
      //  - keeps previous data displayed until new data arrives
      keepPreviousData: true,
      ...options,
    },
  );

  return {
    ...query,
    queryKey,
  };
};

export default useListMediasQuery;
